import type { AppDetail } from '@/lib/types';

/**
 * Which platforms can actually be sent to. The workers treat missing or disabled credentials the same way
 * (every device fails as credentials_missing), so the dashboard checks the same thing before sending.
 */
export function platformsReady(app: AppDetail): Record<'android' | 'ios', boolean> {
  return { android: !!app.android?.enabled, ios: !!app.ios?.enabled };
}
